import { __awaiter } from "tslib";
import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { copyToClipboard, getPassportUrl } from '@/utils/other';
import { mapGetters } from 'vuex';
export default Vue.extend({
    name: 'transfersInbound',
    data: () => ({
        loadError: false,
        isRetry: false,
        havePermissionToTransfer: false,
        selectedAsset: '',
        selectedNetwork: 0,
        addresses: {},
        addressCopied: false,
        kycError: false
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { passportSafety() {
            return getPassportUrl('/id/', { withAcceptor: true });
        },
        transferAvailable() {
            return !this.kycError && this.havePermissionToTransfer;
        }, availableNetworks() {
            var _a;
            const selectedAsset = (_a = this.addresses[this.selectedAsset]) !== null && _a !== void 0 ? _a : {};
            const networks = Object.keys(selectedAsset);
            if (networks.length > 0) {
                return networks;
            }
            return ['TRX', 'ETH', 'BSC'];
        },
        availableAssets() {
            return Object.keys(this.addresses);
        },
        currentAddress() {
            var _a, _b;
            if (!(this.addresses[this.selectedAsset] && this.availableNetworks[this.selectedNetwork]))
                return '';
            return (_b = (_a = this.addresses[this.selectedAsset][this.availableNetworks[this.selectedNetwork]]) === null || _a === void 0 ? void 0 : _a.address) !== null && _b !== void 0 ? _b : '';
        },
        assetAutocompleteItems() {
            return this.availableAssets.map((asset) => ({ label: asset, value: asset }));
        },
        selectedAssetRules() {
            return [
                (v) => v.length > 0 || '',
                (v) => this.addresses[v] !== undefined || this.$t('transfersPage.inbound.errors.assetNotAvailable')
            ];
        } }),
    watch: {
        selectedAsset() {
            const vm = this;
            vm.selectedNetwork = 0;
            vm.addressCopied = false;
        },
        selectedNetwork() {
            const vm = this;
            vm.addressCopied = false;
        }
    },
    methods: {
        handleKYCVerification() {
            window.open(this.passportSafety, '_self');
        },
        init() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                this.loadError = false;
                this.isRetry = true;
                const response = yield this.services.mainService.getTransfersPaymentData(null);
                this.kycError = response.status === 403;
                if (this.kycError) {
                    this.isRetry = false;
                    return;
                }
                if (response.success) {
                    this.addresses = response.data.depositAddress;
                    const assetToDeposit = this.$route.query.deposit;
                    const defaultSelected = this.addresses.USDT !== undefined ? 'USDT' : this.availableAssets[0];
                    this.selectedAsset = ((_a = assetToDeposit !== null && assetToDeposit !== void 0 ? assetToDeposit : defaultSelected) !== null && _a !== void 0 ? _a : 'USDT').toUpperCase();
                }
                else {
                    this.loadError = true;
                }
                this.isRetry = false;
            });
        },
        handleClickCopyAddress() {
            const vm = this;
            copyToClipboard(vm.currentAddress).then(() => {
                vm.addressCopied = true;
            });
        },
        handleClickQR() {
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('transfersPage.popups.qr.header', { asset: vm.selectedAsset, network: vm.availableNetworks[vm.selectedNetwork] }),
                slot: {
                    name: 'qrZoomPopupChunk',
                    data: {
                        qrCode: vm.currentAddress
                    }
                },
                actions: [
                    {
                        title: this.$t('transfersPage.popups.qr.okButton'),
                        isAccent: true,
                        callback() { vm.$store.commit('popupModule/setClosed'); }
                    }
                ]
            });
        }
    },
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            this.havePermissionToTransfer = this.getUserData.permissions.binance.transfers.deposit.available;
        });
    }
});
